<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="notMatchModelForm" :model="notMatchModelForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="机型名称">
              <el-input clearable
                v-model="notMatchModelForm.modelName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getNotMatchModelList">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="orderNo"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="openOrderNo"
            label="渠道订单号">
          </el-table-column>
          <el-table-column
            prop="notModelName"
            label="机型名称">
          </el-table-column>
          <el-table-column
            prop="modelName"
            label="图片机型">
          </el-table-column>
          <el-table-column
            prop="modelCode"
            label="图片机型代码">
          </el-table-column>
          <el-table-column
            prop="publishYear"
            label="年份">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorNotMatchModel(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteNotMatchModel(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑自动出价等级规则' : '新建自动出价等级规则'" :visible.sync="isDlg" width="900px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editNotMatchModelForm" :model="editNotMatchModelForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editNotMatchModelForm.id" :disabled="true"></el-input>
            </el-form-item>
              <el-form-item label="机型ID">
              <el-input clearable v-model="editNotMatchModelForm.modelId" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="机型名称">
              <el-input v-model="editNotMatchModelForm.notModelName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="图片机型名称" prop="modelName">
              <el-input v-model="editNotMatchModelForm.modelName" ></el-input>
            </el-form-item>
            <el-form-item label="图片机型代码" prop="modelCode">
             <el-input v-model="editNotMatchModelForm.modelCode" ></el-input>
            </el-form-item>
            <el-form-item label="机型年代" prop="publishYear">
             <el-input v-model="editNotMatchModelForm.publishYear" ></el-input>
            </el-form-item>
            <el-form-item>
                <el-image
                  v-for="(item, index) in imageList"
                  :key="index"
                  :src="item.url"
                  fit="fill"
                  style="width: 150px; height: 150px; margin: 10px"
                  :preview-src-list="[item.url]"
                >
                </el-image>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据
      isDlg: false,
      editNotMatchModelForm: {
        id: null,
        modelName: null,
        modelCode: null,
        publishYear: null
      },

      editorFormRules: {
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
      },
      dlgType: 'change',
      notMatchModelForm:{
        notModelName:null
      },
      imageList:[]
    }
  },
  watch:{},
  computed:{},
  methods:{
    deleteNotMatchModel(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteNotMatchModel({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getNotMatchModelList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getNotMatchModelList()
    }, 

    // 获取门店列表
    getNotMatchModelList() {
      let self  = this;
      self.$api.listSearchNotMatchModel({
        page: self.currentPage,
        size: self.pageSize,
        modelName: self.notMatchModelForm.modelName || null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 获取门店列表
    getImageList(row) {
      let self  = this;
      self.$api.getImageList(row).then(res => {
         self.imageList = res.data|| []
      })
    },

    // 修改门店
    editorNotMatchModel(row) {
      let self = this;
      self.editNotMatchModelForm=JSON.parse(JSON.stringify(row));
      self.dlgType = 'change'
      this.getImageList(self.editNotMatchModelForm)
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editNotMatchModelForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            self.$api.updateNotMatchModel(self.editNotMatchModelForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getNotMatchModelList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },
  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getNotMatchModelList();
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>